import { DebitCardColour } from 'types/gql-global-types'

export const DEBIT_CARD_COLOURS = [DebitCardColour.WHITE, DebitCardColour.BLACK]
export const EXPENSE_CARD_COLOURS = [
  DebitCardColour.DARKBLUE,
  DebitCardColour.YELLOW,
  DebitCardColour.GREEN,
  DebitCardColour.LIGHTBLUE,
]
